export const SEED_TALENT_UI_TYPES = [
  {
    value: 'seed-talent-webhook',
    label: 'Seed Talent - Employee creation',
    eventType: 'client-seed-talent-integration-webhook'
  },
  {
    value: 'seed-talent-user',
    label: 'Seed Talent - Employee update',
    eventType: 'client-user-seed-talent-integration'
  },
  {
    value: 'seed-talent-sync',
    label: 'Seed Talent - Employee sync (create, status and updates)',
    eventType: 'seed-talent-integration'
  }
];

export const fixedEventTypeFor = (uiType) =>
  SEED_TALENT_UI_TYPES.find((type) => type.value === uiType)?.eventType;

export const seedTalentUiTypeFor = (eventType) =>
  SEED_TALENT_UI_TYPES.find((type) => type.eventType === eventType)?.value;
